export const iconFontAwesomeMedicalHealthDna = (
	<i className="fa-solid fa-dna"></i>
);
